module.exports = __webpack_public_path__ + "static/media/info-palyinfobutton.4c779498.png";